import { render } from "./Organizational-services.vue?vue&type=template&id=290fb3e5&scoped=true"
import script from "./Organizational-services.vue?vue&type=script&lang=js"
export * from "./Organizational-services.vue?vue&type=script&lang=js"

import "./Organizational-services.vue?vue&type=style&index=0&id=290fb3e5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290fb3e5"]])

export default __exports__